declare global {
  interface Window {
    shopify?: {idToken(): Promise<string>; toast?: {show(message: string, options?: {isError?: boolean}): void}};
  }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  headers.set("Accept", "application/json");
  if (init.body) headers.set("Content-Type", "application/json");
  if (window.shopify?.idToken) {
    headers.set("Authorization", `Bearer ${await window.shopify.idToken()}`);
  }
  const wixInstance = new URLSearchParams(window.location.search).get("instance");
  if (wixInstance) headers.set("X-Wix-Instance", wixInstance);
  const response = await fetch(path, {...init, headers});
  const data = await response.json().catch(() => ({error: "Unexpected server response"})) as T & {error?: string; code?: string};
  if (!response.ok) throw new Error(data.error ?? `Request failed (${response.status})`);
  return data;
}

export function notify(message: string, isError = false) {
  if (window.shopify?.toast) window.shopify.toast.show(message, {isError});
}
